import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { ListItem } from "@website/ui/list-item";
import { TransitionV2 } from "@website/ui/transition";
import { getChannel } from "@website/utils/channel/get-channel";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { useToggle } from "@website/utils/use-toggle/useToggle";
import { useServices } from "@website/widget/header";
import LOGO from "@website/widget/header/assets/logo.png";
import LOGO_SNAPP from "@website/widget/header/assets/logo_snapp.svg";
import { useEffect } from "react";

const alt_logo = replaceSnappTripBasedOnChannel("snapptrip");

export function TravelServicesMobileDrawer() {
  const [drawerIsOpen, toggleDrawer] = useToggle(false);
  const { services } = useServices();

  useEffect(() => {
    if (drawerIsOpen) {
      document.body.classList.add("prevent-scroll");
      return () => document.body.classList.remove("prevent-scroll");
    }
  }, [drawerIsOpen]);

  return (
    <>
      <Button
        EndIcon={<MaterialIcon name="menu" />}
        aria-label="open menu"
        className="lg:!hidden"
        color="neutral"
        equalDimension
        onClick={toggleDrawer}
        size="small"
        variant="text"
      />

      <TransitionV2 in={drawerIsOpen} timeout={75}>
        {(state) => (
          <div
            className={`bg-on-color-high-emphasis fixed right-0 top-0 z-50 h-full w-0 overflow-y-auto overflow-x-hidden transition-all ease-in-out ${
              state === "entering" || state === "entered" ? "w-full" : ""
            }`}
          >
            <div className="flex h-16 flex-row items-center gap-2 px-4">
              <Button
                EndIcon={
                  <MaterialIcon name="arrow_forward" variant="outlined" />
                }
                aria-label="close"
                color="neutral"
                equalDimension
                onClick={toggleDrawer}
                size="small"
                variant="text"
              />
              <div className="flex flex-1 items-center justify-start">
                <a aria-label={alt_logo} href="/" itemScope>
                  <LazyImage
                    alt={`${alt_logo} logo`}
                    height={78}
                    loading="eager"
                    src={
                      getChannel() === "snapp-ir" ? LOGO_SNAPP.src : LOGO.src
                    }
                    title={replaceSnappTripBasedOnChannel("اسنپ تریپ")}
                    width={137}
                    className="h-8 w-auto"
                  />
                </a>
              </div>
            </div>
            <nav className="divide-outline-thin divide-y">
              {services.map((item) => (
                <a
                  className="flex"
                  href={item.url}
                  key={item.title}
                  onClick={toggleDrawer}
                >
                  <ListItem
                    EndIcon={
                      <MaterialIcon name="chevron_left" variant="outlined" />
                    }
                    StartIcon={item.icon}
                    data-noindex="true"
                    title={item.title}
                  />
                </a>
              ))}
            </nav>
          </div>
        )}
      </TransitionV2>
    </>
  );
}
